// Redux sets an isDispatching flag while a reducer runs and clears it in a
// `finally`. When the browser stops a long-running script part way through a
// reducer (Firefox's "This page is slowing down Firefox" → Stop), the
// `finally` never runs, so the flag stays set. From then on every getState()
// and dispatch() throws Redux error #3, from any event handler or render,
// and the store cannot recover. Only a reload gives the page a working store.

const STUCK_STORE_PATTERNS = [
	// Production build (formatProdErrorMessage(3))
	'Minified Redux error #3;',
	// Development build
	'You may not call store.getState() while the reducer is executing',
];

export function isStuckStoreError(error: unknown): boolean {
	const message = (error as { message?: unknown } | null)?.message;
	return (
		typeof message === 'string' &&
		STUCK_STORE_PATTERNS.some((pattern) => message.includes(pattern))
	);
}
